<button
  class="btn btn-reverse-dark btn-icon-only panel-button"
  [disabled]="isBackBtnDisabled$ | async"
  (click)="goBack()"
  title="Previous View"
>
  <i class="modus-icons">arrow_left</i>
</button>
<button
  class="btn btn-reverse-dark btn-icon-only panel-button"
  [disabled]="isForwardBtnDisabled$ | async"
  (click)="goForward()"
  title="Next View"
>
  <i class="modus-icons">arrow_right</i>
</button>
